import React from "react";
import UltraModernUserPage from "../components/UltraModernUserPage";

export default function DashboardPage() {
  return <UltraModernUserPage />;
}
